import React, { CSSProperties } from 'react'

import cn from 'classnames'
import { range } from 'lodash'

import classes from './sequence-map.module.scss'
import { Tick } from './tick'

type SequenceMapProps = {
  current: number
  steps?: number
  diameter?: number
  exhausted?: boolean
  className?: string
}

const DEFAULT_STEPS = 2
const DEFAULT_DIAMETER = 40

const enum StepVariant {
  Passed = 'passed',
  Current = 'current',
  Next = 'next',
}

export const SequenceMap = (props: SequenceMapProps) => {
  const {
    current,
    exhausted,
    steps = DEFAULT_STEPS,
    diameter = DEFAULT_DIAMETER,
    className,
  } = props

  const style = {
    width: `${diameter}px`,
    height: `${diameter}px`,
  } satisfies CSSProperties

  const getStepVariant = (step: number): StepVariant => {
    if (exhausted) {
      return StepVariant.Passed
    }

    if (step < current) {
      return StepVariant.Passed
    }

    if (step === current) {
      return StepVariant.Current
    }

    return StepVariant.Next
  }

  const getStep = (step: number) => {
    const variant = getStepVariant(step)
    const className = cn(classes.step, classes[variant])

    return (
      <div
        key={step}
        style={style}
        className={className}
        data-testid={`step-${step}`}
      >
        {variant === StepVariant.Passed ? <Tick /> : step}
      </div>
    )
  }

  return (
    <div
      className={cn(classes.container, className)}
      style={{ height: `${diameter}px` }}
    >
      <div className={classes.line} />
      {range(1, steps + 1).map(getStep)}
    </div>
  )
}
